<template>
  <div class="c-container">
    <div class="c-caption-body" :style="`width: ${width}px`" v-for="(item, idx) in points" :key="idx">
      <div class="c-caption">
        <input-len
          v-model="points[idx]"
          placeholder="6~9个字，1个中文=1个英文=1个字"
          :max="maxLen"
          :width="width"
          charset="init"
        ></input-len>
      </div>
      <div v-if="del" class="c-delete" @click="points.splice(idx, 1)">
        <Icon type="ios-trash-outline" size="22" color="#ff2200" />
      </div>
    </div>
  </div>
</template>
<script>
import { getByteLen } from '@/common/js/utils'
import InputLen from '@/components/input/input-len.vue'
export default {
  name: 'cardCaption',
  components: { InputLen },
  props: {
    value: {
      type: Array
    },
    del: {
      type: Boolean,
      default() {
        return false
      }
    },
    maxLen: {
      type: Number
    },
    width: {
      type: [Number, String]
    }
  },
  computed: {
    points: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    len() {
      return this.title ? getByteLen(this.title) : 0
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.c-caption-body {
  margin-bottom: 12px;
  position: relative;

  .c-delete {
    padding: 5px 0;
    text-align: center;
    position: absolute;
    top: 0;
    right: -40px;
    cursor: pointer;
  }
}
</style>
